// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollToTop__container___37xDi"};